import { render, staticRenderFns } from "./addKeywordPage.vue?vue&type=template&id=5b97ed60&scoped=true&"
import script from "./addKeywordPage.vue?vue&type=script&lang=js&"
export * from "./addKeywordPage.vue?vue&type=script&lang=js&"
import style0 from "./addKeywordPage.vue?vue&type=style&index=0&id=5b97ed60&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b97ed60",
  null
  
)

export default component.exports